import { useState } from 'react';

export default function DonutChart({ segments, centerLabel, centerValue, emptyLabel = "No data available." }) {
  const [hov, setHov] = useState(null);
  const safeSegments = Array.isArray(segments) ? segments : [];
  const total = safeSegments.reduce((sum, segment) => sum + Number(segment.v || 0), 0);

  if (safeSegments.length === 0 || total <= 0) {
    return (
      <div className="py-16 text-center text-muted dark:text-slate-400 text-sm border border-dashed border-border dark:border-slate-700 rounded-xl bg-slate-50/10 dark:bg-slate-900/30">
        {emptyLabel}
      </div>
    );
  }

  let cum = 0; const r = 46, cx = 56, cy = 56, gap = 1;
  const arcs = safeSegments.map(s => {
    const p = s.v / 100; const sa = cum * 360 - 90; cum += p; const ea = cum * 360 - 90; const lg = p > 0.5 ? 1 : 0;
    const toR = d => d * Math.PI / 180;
    const x1 = cx + r * Math.cos(toR(sa + gap)), y1 = cy + r * Math.sin(toR(sa + gap));
    const x2 = cx + r * Math.cos(toR(ea - gap)), y2 = cy + r * Math.sin(toR(ea - gap));
    return { ...s, d: `M${cx} ${cy}L${x1} ${y1}A${r} ${r} 0 ${lg} 1 ${x2} ${y2}Z` };
  });
  const rawLabel = hov !== null ? arcs[hov]?.label : centerLabel;
  const activeLabel = (rawLabel === "Expense Breakdown" || rawLabel === "Expenses by Category") ? "Expenses" : (rawLabel || "");
  const labelFontSize = activeLabel.length > 12 ? 6.5 : activeLabel.length > 9 ? 7.5 : 8;

  return (
    <div className="flex items-center gap-6">
      <svg width={112} height={112} viewBox="0 0 112 112" className="flex-shrink-0">
        {arcs.map((a, i) => (
          <path key={i} d={a.d} fill={hov === i ? a.hoverColor || a.color : a.color} stroke="var(--color-surface)" strokeWidth={2}
            onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)} style={{ cursor: "pointer", transition: "all 0.2s" }} />
        ))}
        <circle cx={cx} cy={cy} r={28} fill="var(--color-surface)" />
        <text
          x={cx}
          y={cy - 5}
          textAnchor="middle"
          fontSize={labelFontSize}
          fill="#475569"
          fontWeight="600"
          className="fill-slate-600 dark:fill-slate-300"
        >
          {activeLabel}
        </text>
        <text
          x={cx}
          y={cy + 9}
          textAnchor="middle"
          fontSize={11}
          fontWeight="700"
          fill="var(--color-ink)"
          className="fill-slate-900 dark:fill-slate-100"
        >
          {hov !== null ? `${arcs[hov]?.v}%` : centerValue}
        </text>
      </svg>
      <div className="space-y-2 flex-1">
        {arcs.map((a, i) => (
          <div key={i} className={`flex items-center gap-2 text-xs cursor-pointer rounded-lg p-1.5 -mx-1.5 transition-colors ${hov === i ? "bg-slate-50 dark:bg-slate-800" : ""}`}
            onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
            <span className="w-2.5 h-2.5 rounded-sm flex-shrink-0" style={{ background: a.color }} />
            <span className="text-slate-600 dark:text-slate-300 font-medium flex-1">{a.label}</span>
            <span className="font-bold text-ink dark:text-slate-100">{a.v}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}
